<template>
  <svg t="1705730378235" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10495" width="16" height="16">
    <path
      d="M160 896a32 32 0 0 1 0-64h704a32 32 0 0 1 0 64z m91.52-111.68a32 32 0 1 1-55.04-32l38.4-64A32 32 0 0 1 262.4 672h499.2a32 32 0 0 1 27.52 15.68l38.4 64a32 32 0 1 1-55.04 32L743.36 736H280.64zM608 224a96 96 0 1 0-96 96 96 96 0 0 0 96-96z m64 0A160 160 0 1 1 512 64a160 160 0 0 1 160 160z"
      p-id="10496"
      fill="#fba804"
    ></path>
    <path
      d="M416 343.68a32 32 0 1 1 61.44 16.64l-96 352A32 32 0 1 1 320 695.68z m128 16.64a32 32 0 0 1 64-16.64l96 352a32 32 0 1 1-61.44 16.64z"
      p-id="10497"
      fill="#fba804"
    ></path>
  </svg>
</template>
